import { Box, Heading } from '@99designs/emu';
import { FlexibleColumnFAQs, GridLayout, QuestionAnswerProps } from '@99designs/marketing-ui';
import { TabId } from '../TabsMenu';

interface Props {
    faqs: QuestionAnswerProps[];
}

export function FAQSection({ faqs }: Props) {
    return (
        <Box id={TabId.Faq}>
            <GridLayout>
                <Heading appearanceLevel={3} accessibilityLevel={2}>
                    Frequently asked questions
                </Heading>
                <Box display="flex" paddingY="2bu" flexDirection="column">
                    <FlexibleColumnFAQs faqSections={[faqs]} />
                </Box>
            </GridLayout>
        </Box>
    );
}
